import {AxisRange, svgDimensions} from 'components/dashboard/manager/nine-box/NineBox.const';
import React from 'react';

const FONT_SIZE = 7;

interface AxisLabelsProps {
  xRange: AxisRange;
  yRange: AxisRange;
}

interface AxisLabelProps {
  value: string;
  pos: Position;
}

interface Position {
  x: number;
  y: number;
  anchor: 'start' | 'middle' | 'end';
}

const yOffset = svgDimensions.height + 10; // How far x values are from the chart
const xOffset = -5; // How far y values are from the chart

const yStart: Position = {x: xOffset, y: svgDimensions.height, anchor: 'end'};
const yEnd: Position = {x: xOffset, y: FONT_SIZE, anchor: 'end'};
const xStart: Position = {x: 0, y: yOffset, anchor: 'start'};
const xEnd: Position = {x: svgDimensions.width, y: yOffset, anchor: 'end'};
const sharedStart: Position = {x: xOffset, y: yOffset, anchor: 'middle'};

function AxisLabel({value, pos}: AxisLabelProps) {
  return (
    <text x={pos.x} y={pos.y} textAnchor={pos.anchor} fill="#808080" fontSize={7}>
      {value}
    </text>
  );
}

export default function AxisLabels({xRange, yRange}: AxisLabelsProps) {
  return (
    <>
      {xRange.start === yRange.start ? (
        <AxisLabel value={xRange.start} pos={sharedStart} />
      ) : (
        <>
          <AxisLabel value={xRange.start} pos={xStart} />
          <AxisLabel value={yRange.start} pos={yStart} />
        </>
      )}

      <AxisLabel value={xRange.end} pos={xEnd} />
      <AxisLabel value={yRange.end} pos={yEnd} />
    </>
  );
}
